module.exports = __webpack_public_path__ + "img/activity.90f9df3f.png";